/**
 * Favicon URL for a tool card.
 *
 * Google's favicon service is used as a single, cacheable source; when it fails
 * (offline, blocked, or a 1×1 placeholder) the card falls back to the tool's
 * monogram, so nothing here is load-bearing for the layout.
 */
export function faviconUrl(domain: string, size = 128): string {
  return `https://www.google.com/s2/favicons?sz=${size}&domain=${encodeURIComponent(domain)}`;
}

/**
 * Google returns a 16×16 globe placeholder for unknown domains. Treating that
 * as a failure keeps the branded monogram instead of a generic grey globe.
 */
export const MIN_USABLE_LOGO_PX = 17;
